import { Navigate, RouteObject } from "react-router-dom"
import { SuspiciousActivityPage, VerificationPage } from "../pages"

const suspiciousActivityRoutes: RouteObject[] = [
    {
        path: '/',
        element: <SuspiciousActivityPage />
    },
    {
        path: 'suspicious-activity/verification',
        element: <VerificationPage />
    },
    {
        path: '*',
        element: <Navigate to="/" replace />
    }
]

export default suspiciousActivityRoutes